/* eslint-disable */
export default {
  confirmationInfo:
    'Le modifiche non salvate alla chiamata precedente saranno perse. Elaborare comunque la nuova chiamata?',
  log: 'Registro',
  save: 'Salva ed elabora nuova',
  discard: 'Non salvare ed elabora nuova',
  stay: 'Continua su precedente',
} as const;

// @key: @#@"confirmationInfo"@#@ @source: @#@"Your unsaved edits on the previous call will be lost, are you sure you want to work on the new call?"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save & Work on New"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard & Work on New"@#@
// @key: @#@"stay"@#@ @source: @#@"Stay on Previous Work"@#@
